import { render, staticRenderFns } from "./lawsjxlmtj.vue?vue&type=template&id=caf053bc&"
import script from "./lawsjxlmtj.vue?vue&type=script&lang=js&"
export * from "./lawsjxlmtj.vue?vue&type=script&lang=js&"
import style0 from "./lawsjxlmtj.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports